import React from 'react';

const OpenKnotsLoginFooter = () => {
    return (
        <>
            <div className='opk-login-footer'>
                <div className='opk-login-dots'>
                    <span />
                    <span />
                    <span className='is-active' />
                    <span />
                </div>
                <p className='opk-login-headline'>
                    Your bunker desk,
                </p>
                <p className='opk-login-headline'>now on WhatsApp
                </p>
                <p className='opk-login-subhead'>Start today with Bunk Coin.</p>
            </div>
        </>
    );
};

export default OpenKnotsLoginFooter;